import {
  KB_TRACKED_PAGE_FILTER,
  type KBWebsitePageFilter,
} from '@kanbu/schema/contracts';
import { WebsitePageStatus } from '@kanbu/schema/enums';

export { KB_TRACKED_PAGE_FILTER, type KBWebsitePageFilter };

export function isKBTrackedPageFilter(
  filter: KBWebsitePageFilter | undefined,
): filter is typeof KB_TRACKED_PAGE_FILTER {
  return filter === KB_TRACKED_PAGE_FILTER;
}

export function parseKBWebsitePageFilter(
  value: string | undefined,
): KBWebsitePageFilter | undefined {
  if (value === KB_TRACKED_PAGE_FILTER) {
    return KB_TRACKED_PAGE_FILTER;
  }

  if (
    value !== undefined &&
    Object.values(WebsitePageStatus).includes(value as WebsitePageStatus)
  ) {
    return value as WebsitePageStatus;
  }

  return undefined;
}

export function toFindContentsPageFilter(
  filter: KBWebsitePageFilter | undefined,
): {
  status?: WebsitePageStatus;
  pageHasDocument?: boolean;
} {
  if (filter === undefined) {
    return {};
  }

  if (isKBTrackedPageFilter(filter)) {
    return { pageHasDocument: true };
  }

  return { status: filter };
}
